angular.module('impactx.rfx').controller('RFXItemCompareCommentCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    'ToolbarService',
    'TranslationService',
    '$mdDialog',
    RFXItemCompareCommentCtrl
]);

function RFXItemCompareCommentCtrl($scope, $routeParams, dataGen, ToolbarService, TranslationService, $mdDialog) {
    var self = this;
    var dialogItem = self.item;
    self.item = JSON.parse(JSON.stringify(self.item));
    $scope.abortLabel = TranslationService.get("abort");
    $scope.saveLabel = TranslationService.get("save");

    self.abort = function () {
        $mdDialog.cancel();
    };

    self.save = function () {
        dataGen.postAsForm({}, {rfqiId: self.item.rfqiId, comment: self.item.comment.value}, "/rfx/itemcompare/savecomment").then(function () {
            $scope.summary = tempScope.data;
        });
        dialogItem.comment = self.item.comment;
        $mdDialog.hide();
    };

}